import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Card from '../../components/elements/Card';
import SameLine from '../../components/css/SameLine';
import { t } from 'i18next';
import { fetchUserInfo, formatDate } from '../../utils';
import Icon from '../../components/common/Icon';

const ExtraPointsPage = () => {
  const [extraPoints, setExtraPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

   useEffect(() => {
    fetchUserInfo(
      '/team/extra-points',
      (data) => setExtraPoints(data.extra_points),
      setLoading,
      setError,
      []
    );
  }, []);

  return (
    <Base>
      <Back to="/team" />
      <Title>{t('extraPoints')}</Title>

      {loading && <p>{t('Loading...')}</p>}
      {error && <p className="text-danger">{t(error)}</p>}

      {!loading && extraPoints?.length === 0 && (
        <p style={{ textAlign: 'center', marginTop: '2rem' }}>
          {t('noExtraPoints')}
        </p>
      )}

      {extraPoints?.map((point, index) => (
        <Card key={index} mx="3" mb="2">
              <h5>
                <Icon name='benefit-hand' className='me-2' theme='primary' />
                {(point.type || t('noType'))
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (c) => c.toUpperCase())}
              </h5>

              <p>{point.comment}</p>
              <p><strong>{t('points')}:</strong> +{point.points}</p>
              <p><strong>{t('date')}:</strong> {formatDate(point.date)}</p>
            
        </Card>
      ))}
    </Base>
  );
};

export default ExtraPointsPage;
